<template>
  <div>
    <b-card no-body v-if="this.syncResult">
      <b-card-body>
        <b-container fluid="xl">
          <b-row v-if="showOrganisation">
            <b-col cols="12">
              <b>{{syncResult.organisationName}}</b>
              <p/>
            </b-col>
          </b-row>
          <b-row align-v="center">
            <b-col cols="2">
              Type
              <div>
                <b>{{ syncResult.syncType}}</b>
              </div>
            </b-col>
            <b-col cols="2">
              Last sync
              <div>
                <b>{{ $formatDateTime(new Date(syncResult.timestamp)) }}</b>
              </div>
            </b-col>
            <b-col cols="2">
              Duration
              <div>
                <b>{{ $formatDuration(syncResult.duration/1000) }}</b>
              </div>
            </b-col>
            <b-col cols="2">
              Success
              <div>
                <b>{{ syncResult.success }}</b>
              </div>
            </b-col>
            <b-col cols="2">
              <base-button size="sm" type="primary" v-b-toggle="'configuration' + this.syncResult.timestamp" class="m-1">Configuration</base-button>
              <base-button size="sm" type="primary" v-b-toggle="'changelog' + this.syncResult.timestamp" class="m-1" v-if="this.syncResult.changelog">Changelog</base-button>
              <base-button size="sm" type="primary" v-b-toggle="'error' + this.syncResult.timestamp" class="m-1" v-if="this.syncResult.errors">Errors</base-button>
            </b-col>
          </b-row>
        </b-container>
      </b-card-body>
    </b-card>
    <b-collapse :id="'error' + this.syncResult.timestamp">
      <b-row cols="12">
        <b-col cols="1">
        </b-col>
        <b-col cols="11">
          <b-card>
            <h2>Errors</h2>
            <p/>
            <div v-for="(log, index) in this.syncResult.errors">{{ log }}</div>
          </b-card>
        </b-col>
      </b-row>
    </b-collapse>
    <b-collapse :id="'changelog' + this.syncResult.timestamp">
      <b-row cols="12">
        <b-col cols="1">
        </b-col>
        <b-col cols="11">
          <b-card>
            <h2>Changelog</h2>
            <p/>
            <div v-for="(log, index) in this.syncResult.changelog">{{ log }}</div>
          </b-card>
        </b-col>
      </b-row>
    </b-collapse>
    <b-collapse :id="'configuration' + this.syncResult.timestamp">
      <b-row cols="12">
        <b-col cols="1">
        </b-col>
        <b-col cols="11">
          <b-card>
            <h2>Configuration</h2>
            <p/>
            <b-row>
              <b-col cols="3">
                <div>
                  Remote organisation : <b>{{ this.syncResult.syncConfiguration.remoteOrganisation }}</b>
                </div>
                <div>
                  Remote server : <b>{{ this.syncResult.syncConfiguration.server }}</b>
                </div>
                <div>
                  Sync active : <b>{{ !this.syncResult.syncConfiguration.syncInactive }}</b>
                </div>
              </b-col>
              <b-col cols="3">
                <div>Devices : <b>{{ this.syncResult.syncConfiguration.syncDevices }}</b></div>
                <div>Assets : <b>{{ this.syncResult.syncConfiguration.syncAssets }}</b></div>
                <div>Drivers : <b>{{ this.syncResult.syncConfiguration.syncDrivers }}</b></div>
                <div>Groups : <b>{{ this.syncResult.syncConfiguration.syncGroups }}</b></div>
                <div>Configuration groups : <b>{{ this.syncResult.syncConfiguration.syncConfigurationGroups }}</b></div>
              </b-col>
            </b-row>

          </b-card>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: "sync-result-card",
  props: {
    syncResult: {
      type: Object,
      description: "Sync result object"
    },
    showOrganisation: {
      type: Boolean,
      default: false,
      description: "Whether organisation info needs to be shown"
    },
  },
}
</script>

<style scoped>

</style>
